import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

let lang = localStorage.getItem('defaultLang') || 'en';

// console.log(lang, 'lang')
// zh: 中文;
// cs: 捷克语;
// it: 意大利语;
// de: 德语;
// jp: 日语;
// pt-br: 巴西语;
// ko: 韩语;
// en: 英语;
// zh-tw: 中文（繁體）;
// fr: 法语;
// es: 西班牙语;
// ru: 俄语;
// ar: 阿拉伯语;
// pt: 葡萄牙语;

const messages = {
	'zh': require('./zh.json'),
	'cs': require('./cs.json'), 
	'it': require('./it.json'),
	'de': require('./de.json'),
	'jp': require('./jp.json'),
	'pt-br': require('./pt-br.json'),
	'ko': require('./ko.json'),
	'en': require('./en.json'),
	'zh-tw': require('./zh-tw.json'),
	'fr': require('./fr.json'),
	'es': require('./es.json'),
	'ru': require('./ru.json'),
	'ar': require('./ar.json'),
	'pt': require('./pt.json'),
};

const i18n = new VueI18n({
	globalInjection: true,
	locale: lang,
	messages,
});

export default i18n;